import React, {Component} from 'react';
import './App.scss';
import Show3D from './Show-3D/Show-3D';
import RightSelectors from './right-selectors/right-selectors';
import Banner from './banner/banner';
import Footer from './footer/footer';
import LeftMenu from './left-menu/left-menu';
import { Event } from "./common/event";
import { isPC } from './common/config';

class App extends Component {

    constructor(props) {
        super(props);
        if(!isPC()) {
          this.state = {
            showLeft: false,
            showRight: false
          }
        }else {
          this.state = {
            showLeft: true,
            showRight: true
          }
        }
    }

    componentDidMount() {
      if(!isPC()) {
        Event.on('ShowRight',(data)=>{
          switch(data) {
            case 1:
              this.setState({showLeft: true});
              break;
            case 2:
              this.setState({showRight: true});
              break;
            default:
              this.hidden();
              break;
          }
        });
      }
    }

  render() {
        return (
            <div className="App">
                <Banner></Banner>
                <div className="main">
                    <div className="center">
                        <div className="center-inner">
                            <Show3D></Show3D>
                        </div>
                    </div>
                    <div className={this.state.showLeft ? 'showRight left' : 'left'}>
                        <LeftMenu></LeftMenu>
                    </div>
                    <div className={this.state.showRight ? 'showRight right' : 'right'}>
                        <RightSelectors></RightSelectors>
                    </div>

                </div>
                <Footer></Footer>
                <div onClick={this.hidden.bind(this)} className={this.state.showLeft || this.state.showRight ? 'showRight backdrop' : 'backdrop'}></div>
            </div>

        );
    }

  hidden(){
      this.setState({
        showLeft: false,
        showRight: false
      })
  }

}

export default App;
